import request from '@/utils/request'

export function getNoticeList(param) {
  let data = param
  return request({
    url: `/zdmin/epmsZ000/getNoticeList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function getContents(url) {
  return request({
    url: `/ftpDownload${url}`,
    method: 'GET',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' }
  })
}

export function epmsZ000Save(param) {
  let data = param
  return request({
    url: `/zdmin/epmsZ000/epmsZ000Save`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epmsZ000Delete(param) {
  let data = param
  return request({
    url: `/zdmin/epmsZ000/epmsZ000Delete`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epmsZ005List(param) {
  let data = param
  return request({
    url: `/zdmin/epmsZ000/epmsZ005List`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epmsZ005Save(param) {
  let data = param
  return request({
    url: `/zdmin/epmsZ000/epmsZ005Save`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'multipart/form-data' },
    data
  })
}